import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { DEFAULT_CATEGORY_PAGE_SIZE } from '@/constants/general'
import { unZipMyGame } from '@/store/my-games/utils'

import { useUserStore } from '../user-store/user-store'
import type { ShortMyGameZipType } from './utils'

const MY_GAMES_LIMIT = DEFAULT_CATEGORY_PAGE_SIZE * 3

export const useMyGamesStore = defineStore(
    'my-games',
    () => {
        const myGames = ref<ShortMyGameZipType[]>([])
        const userStore = useUserStore()

        const myUnzippedGames = computed(() => myGames.value.map(unZipMyGame))

        function update(inputGame: ShortMyGameZipType): void {
            const [hru] = inputGame
            userStore.updateUsersGame(hru)
            const existingGame = myGames.value.find(([gameHru]) => gameHru === hru)
            /* put always input game for migration purposes */
            myGames.value = existingGame
                ? [inputGame, ...myGames.value.filter(([gameHru]) => gameHru !== hru)]
                : [inputGame, ...myGames.value].slice(0, MY_GAMES_LIMIT)
        }

        return {
            myGames,
            myUnzippedGames,
            update,
        }
    },
    {
        persist: {
            pick: ['myGames'],
            afterHydrate: (ctx) => {
                if (ctx.store._storageListenerAdded) {
                    return
                }
                ctx.store._storageListenerAdded = true
                window.addEventListener('storage', (e: StorageEvent) => {
                    if (e.key === ctx.store.$id) {
                        ctx.store.$hydrate()
                    }
                })
            },
        },
    },
)
